import React from 'react';
import WordDocumentIcon from '../../assets/icons/word-icon.png';
import Chevron from '../../assets/icons/chevron.svg';
import DocumentIcon from '../../assets/icons/pdf2.svg';
import { API_URL } from './settings';
import { getFileUrl } from './utils';
import { FaLink } from 'react-icons/fa6';
import { trackDocumentClick } from '@src/utils/trackDocumentClick';

const icons = {
  pdf: DocumentIcon,
  docx: WordDocumentIcon,
};

const FeaturedDocument = ({ title, fileUrl = '', document, originalId }) => {
  if (fileUrl) {
    const cleanUrl = fileUrl.split('?')[0];
    const ext = cleanUrl.split('.').pop().toLowerCase();
    const icon = icons[ext];

    const handleClick = () => {
      trackDocumentClick(
        { name: title, fileUrl, originalId: originalId || document?.originalId },
        { source: 'table_featured', outcome: 'opened', destinationUrl: fileUrl },
      );
      window.open(fileUrl, '_blank');
    };

    return (
      // TODO: Add a link to the file
      <div className="featured-document-card" onClick={handleClick}>
        <p>{title}</p>
        <img src={Chevron} className="chevron" alt="" />
        <div className="img-container" onClick={() => window.open(fileUrl, '_blank')}>
          {icon ? (
            <img src={icon} alt="Document icon" />
          ) : (
            <FaLink size={35} style={{ color: 'hsla(var(--mmc-pink))' }} />
          )}
        </div>
      </div>
    );
  }

  const icon = fileUrl.includes('.pdf')
    ? DocumentIcon
    : fileUrl.includes('.docx')
    ? WordDocumentIcon
    : null;

  const apiFileUrl = `${API_URL}/${getFileUrl(fileUrl)}?id=${document?.originalId}`;

  const handleClick = () => {
    trackDocumentClick(
      { name: title, fileUrl: apiFileUrl, originalId: document?.originalId || originalId },
      { source: 'table_featured', outcome: 'opened', destinationUrl: apiFileUrl },
    );
    window.open(apiFileUrl, '_blank');
  };

  return (
    // TODO: Add a link to the file
    <div className="featured-document-card" onClick={handleClick}>
      <p>{title}</p>
      {icon && (
        <>
          <img src={Chevron} className="chevron" alt="" />
          <div className="img-container" onClick={() => window.open(fileUrl, '_blank')}>
            <img src={icon} alt="Document icon" />
          </div>
        </>
      )}
    </div>
  );
};

export default FeaturedDocument;
